import { useEffect, useRef, useState } from "react";
import {
    Container,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    useTheme,
} from "@mui/material";
import {
    BarChart, Bar,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";
import { useAuth } from "../../../hooks/useAuth";
import { getPunchDetails } from "../../../hooks/apiHandler"; // Replace with actual API for employee shifts
import { fetchTimeandDateRange } from "../../../hooks/commanFunc";

export const EmployeeShiftReport = ({ reportRange }) => {
    const theme = useTheme();
    const { Logout } = useAuth();
    const storeID = useRef(JSON.parse(window.localStorage.getItem("ds")));

    const [shiftChart, setShiftChart] = useState([]);
    const [shiftSummary, setShiftSummary] = useState([]);
    const [totalShifts, setTotalShifts] = useState(0);
    const [totalHours, setTotalHours] = useState(0);

    useEffect(() => {
        async function fetchShifts() {
            try {

                console.log('First IS error.....');
                console.log(reportRange);
                var { start, end } = await fetchTimeandDateRange(reportRange.toLowerCase());

                console.log('Fetch Time and Date Range...');
                console.log(start);
                console.log(end);

                const response = await getPunchDetails({
                    storeID: storeID.current,
                    startDate: start.toISOString(),
                    endDate: end.toISOString(),
                }, Logout);



                const data = response?.data;
                if (!data) return;

                // const hourlyLogins = {};
                // const employeeMap = {};
                // let shiftCount = 0;
                // let totalShiftHours = 0;

                // Example source: assuming shift logs are within `cashCounts`
                // (data.cashCounts || []).forEach(entry => {
                //     const userID = entry.userID;
                //     const time = new Date(entry.time);
                //     const hour = time.getHours();

                //     hourlyLogins[hour] = (hourlyLogins[hour] || 0) + 1;
                //     employeeMap[userID] = (employeeMap[userID] || 0) + 1;
                //     shiftCount++;
                //     // Example approximation: 1 entry = 30 mins shift (customize as needed)
                //     totalShiftHours += 0.5;
                // });
                // (data || []).forEach(employee => {
                //     const userID = employee.userID;

                //     (employee.punches || []).forEach(punch => {
                //         const time = new Date(punch.startTime);
                //         const hour = time.getHours();

                //         hourlyLogins[hour] = (hourlyLogins[hour] || 0) + 1;
                //         employeeMap[userID] = (employeeMap[userID] || 0) + 1;
                //         shiftCount++;
                //         totalShiftHours += 0.5; // still assuming each punch = 30 min
                //     });
                // });


                // const chartData = Object.entries(hourlyLogins).map(([h, count]) => ({
                //     hour: `${h}:00`,
                //     count,
                // }));




                // setShiftChart(chartData);
                // setShiftSummary(summaryData);
                // setTotalShifts(shiftCount);
                // setTotalHours(totalShiftHours.toFixed(1));

                const dateWiseEmployeeMap = {};
                const employeeMap = {}; // reset here
                const userIdToName = {};

                let shiftCount = 0;
                let totalShiftHours = 0;

                (data || []).forEach(employee => {
                    const userID = employee.userID;
                    userIdToName[userID] = employee.name;

                    (employee.punches || []).forEach(punch => {
                        const punchDate = new Date(punch.startTime).toISOString().split("T")[0]; // yyyy-mm-dd

                        if (!dateWiseEmployeeMap[punchDate]) {
                            dateWiseEmployeeMap[punchDate] = {};
                        }

                        // add to date-wise
                        dateWiseEmployeeMap[punchDate][userID] =
                            (dateWiseEmployeeMap[punchDate][userID] || 0) + 0.5; // each punch = 30 min

                        // add to employee summary
                        employeeMap[userID] = (employeeMap[userID] || 0) + 1;

                        shiftCount++;
                        totalShiftHours += 0.5;
                    });
                });

                // Convert into recharts format
                // Convert into recharts format
                const chartData = Object.entries(dateWiseEmployeeMap).map(([date, users]) => {
                    const entry = { date };

                    // replace userID keys with employee names
                    Object.entries(users).forEach(([userID, count]) => {
                        const name = userIdToName[userID] || userID; // fallback to ID if name missing
                        entry[name] = count; // ✅ use name instead of ID
                    });

                    return entry;
                });

                // build summary with names

                // const chartData = Object.entries(dateWiseEmployeeMap).map(([date, users]) => ({
                //     date,
                //     ...users,
                // }));

                // build summary for table + legend
                // const summaryData = Object.entries(employeeMap).map(([user, count]) => ({
                //     user,
                //     shifts: count,
                //     estimatedHours: (count * 0.5).toFixed(1),
                // }));

                const summaryData = Object.entries(employeeMap).map(([userID, count]) => ({
                    user: userID,
                    name: userIdToName[userID],
                    shifts: count,
                    estimatedHours: (count * 0.5).toFixed(1),
                }));

                setShiftChart(chartData);
                setShiftSummary(summaryData);
                setTotalShifts(shiftCount);
                setTotalHours(totalShiftHours.toFixed(1));
            } catch (err) {
                console.error("Failed to fetch employee shift data", err);
            }
        }

        fetchShifts();
    }, [reportRange, Logout]);

    // if (reportRange !== "today" && reportRange !== "yesterday") {
    //     return <Typography>No Data To Display</Typography>;
    // }

    return (
        <Container sx={{ mt: 4, mb: 4 }}>
            {/* 1. Shift Chart */}
            {/* <Paper elevation={3} sx={{ p: 3, mb: 3, backgroundColor: "#fce4ec" }}>
                <Typography variant="h6" color="secondary" gutterBottom>
                    Employee Logins by Hour
                </Typography>
                <LineChart width={600} height={250} data={shiftChart}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="hour" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey="count"
                        stroke={theme.palette.secondary.main}
                    />
                </LineChart>
            </Paper> */}
            {/* <Paper elevation={3} sx={{ p: 3, mb: 3, backgroundColor: "#fce4ec" }}>
                <Typography variant="h6" color="secondary" gutterBottom>
                    Employee Shift Hours by Date
                </Typography>
                <LineChart width={600} height={250} data={shiftChart}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis label={{ value: "Shift Hours", angle: -90, position: "insideLeft" }} />
                    <Tooltip />
                    <Legend />
                    {shiftSummary.map((row) => (
                        <Line
                            key={row.user}
                            type="monotone"
                            dataKey={row.user}
                            stroke={theme.palette.secondary.main}
                            dot={true}
                        />
                    ))}
                </LineChart>
            </Paper> */}

            <Paper
                elevation={3}
                sx={{ p: 3, mb: 3, backgroundColor: "#fce4ec" }}
            >
                <Typography variant="h6" color="secondary" gutterBottom>
                    Employee Shift Hours by Date
                </Typography>
                {console.log(shiftChart)}
                <BarChart width={600} height={250} data={shiftChart}>
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="date" />
    <YAxis label={{ value: "Shift Hours", angle: -90, position: "insideLeft" }} />
    <Tooltip />
    <Legend />
    {shiftSummary.map((row, index) => (
        <Bar
            key={row.user}
            dataKey={row.name}   // ✅ use name here
            fill={index % 2 === 0 ? "#f06292" : "#9575cd"}
        />
    ))}
</BarChart>
            </Paper>




            {/* 2. Summary Table */}
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper elevation={2} sx={{ p: 3, backgroundColor: "#f3e5f5" }}>
                        <Typography variant="h6" color="primary" gutterBottom>
                            Employee Shift Summary
                        </Typography>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Employee Name</TableCell>
                                    <TableCell >Employee Type</TableCell>
                                    <TableCell align="right">Total No of Shifts</TableCell>
                                    <TableCell align="right">Estimated Hours</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {shiftSummary.map((row) => (<>


                                    <TableRow key={row.user}>
                                        <TableCell>{row.name}{ }</TableCell>
                                         <TableCell>Admin</TableCell>
                                        <TableCell align="right">{row.shifts}</TableCell>
                                        <TableCell align="right">{row.estimatedHours}</TableCell>
                                    </TableRow>
                                </>
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>
            </Grid>

            {/* 3. Footer Summary */}
            <Paper elevation={2} sx={{ p: 3, mt: 3, backgroundColor: "#e1f5fe" }}>
                <Typography variant="h6" color="info.main" gutterBottom>
                    Shift Totals
                </Typography>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>Total Shifts</TableCell>
                            <TableCell align="right">{totalShifts}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Estimated Total Hours</TableCell>
                            <TableCell align="right">{totalHours}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
        </Container>
    );
};
